import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const ChatConversation = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 25" a11yTitle="ChatConversation" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M21 1C22.6569 1 24 2.34315 24 4V11C24 12.6569 22.6569 14 21 14H20V19.4141L16.9736 16.3877C16.7834 17.8613 15.5254 19 14 19H11.3516L5 24.0811V19H3C1.34315 19 0 17.6569 0 16V9C0 7.34315 1.34315 6 3 6H7V4C7 2.34315 8.34315 1 10 1H21ZM3 8C2.44772 8 2 8.44772 2 9V16C2 16.5523 2.44772 17 3 17H7V19.918L10.375 17.2188L10.6494 17H14C14.5523 17 15 16.5523 15 16V9C15 8.44772 14.5523 8 14 8H3ZM10 3C9.44771 3 9 3.44772 9 4V6H14C15.6569 6 17 7.34315 17 9V13.5859L18 14.5859V12H21C21.5523 12 22 11.5523 22 11V4C22 3.44772 21.5523 3 21 3H10Z" fill="#000" />
  </StyledIcon>
));

ChatConversation.displayName = 'ChatConversation';

export { ChatConversation };
